'use strict';

angular.module('membership')
  .service('modifyAgentViewModel', [
    'Ownership', 'modalDialogService', '$stateParams', '$state',
    function(ownership, modalDialogService, $stateParams, $state) {

      var viewModel = function(modalInstance, selectedId, selectedName, ownershipvm) {

        var self = this;
        self.displayedName = selectedName;
        self.modifyData = {};
        self.modifyData.Id = selectedId;
        self.ownershipvm = ownershipvm;
        
        self.modify = function () {
          ownership.modifyOwnership(self.modifyData, function (data) {
            self.ownershipvm.datatablesConfig.reload();
            modalInstance.close();
          });
        }
      };

      return viewModel;

    }
  ]);
